import { Component, Input, OnInit } from '@angular/core';
import { Menu } from '@caslink/common-client';
import { MenuService } from '@captiveaire/menu';

@Component({
    selector: 'cl-menu',
    templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {
    static $name: string = 'clMenu';

    @Input() positionMode: string;
    @Input() viewModel: any;
    @Input() text = '';
    @Input() menuData: Menu;

    isReady: boolean = false;

    get menuDataItems() {
        return this.menuData?.items ? Object.keys(this.menuData?.items).map(m => this.menuData.items[m]) : [];
    }

    ngOnInit() {
        this.menuService.filterMenu(this.menuData).then((result: Menu) => {
            this.menuData = result;
            this.isReady = true;
        });
    }

    constructor(
        private menuService: MenuService
    ) {
    }
}
